'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.doRefreshToken = exports.validateToken = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _nodeFetch = require('node-fetch');

var _nodeFetch2 = _interopRequireDefault(_nodeFetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var validateToken = exports.validateToken = function () {
  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(accessToken, authService) {
    var resp, payload;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _nodeFetch2.default)(authService + '/authorise?access_token=' + accessToken);

          case 2:
            resp = _context.sent;

            if (!(resp.status === 200)) {
              _context.next = 8;
              break;
            }

            _context.next = 6;
            return resp.json();

          case 6:
            payload = _context.sent;
            return _context.abrupt('return', payload.id);

          case 8:
            return _context.abrupt('return', null);

          case 9:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function validateToken(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
/* istanbul ignore next */
var doRefreshToken = exports.doRefreshToken = function () {
  var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(refreshToken, authService) {
    var resp, payload;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _nodeFetch2.default)(authService + '/token/', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              },
              body: 'grant_type=refresh_token&refresh_token=' + refreshToken + '&client_id=' + process.env.WEB_CLIENT_ID
            });

          case 2:
            resp = _context2.sent;
            _context2.next = 5;
            return resp.json();

          case 5:
            payload = _context2.sent;

            if (!(resp.status === 200)) {
              _context2.next = 8;
              break;
            }

            return _context2.abrupt('return', payload);

          case 8:
            throw new Error((0, _stringify2.default)(payload));

          case 9:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function doRefreshToken(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/web-common/dist/tokenHandler/api.js
// module id = 721
// module chunks = 11